namespace AgerLMS.Coaching {
    export interface ChartData {
        categories?: string[];
        seriesData?: ChartDataSeries[];
        avg?: number;
        total?: number;
    }
}
